import { render, staticRenderFns } from "./SystemInfo.vue?vue&type=template&id=7ed8ff4d"
import script from "./SystemInfo.vue?vue&type=script&lang=js"
export * from "./SystemInfo.vue?vue&type=script&lang=js"
import style0 from "./SystemInfo.vue?vue&type=style&index=0&id=7ed8ff4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports